function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M279.63,65.24s4.61-60-97.78-62C110.12,1.87,9.76,55.54.27,177.5h0C.16,180,0,185.38,0,187.85,0,272.66,49.11,289,49.11,289s-17.21-27.72-4.88-57.31c0,0-7.88,75.54,75.91,75.48,0,0-22.62-15.17-25-39,0,0,55,59.51,123.89,11,0,0-107.16,3.54-129.31-79.39,0,0,11.74,15.71,33.46,31.41,26.21,18.93,67,37.85,119.33,29.27,0,0-45.51-17.58-42.83-68.46S255,129.74,255,129.74a79.89,79.89,0,0,0-62.13-28c-1.08,0-2.2,0-3.27,0,3.37-.22,6.75-.32,10.13-.38h1.93S298,90.06,287.57,125.66c0,0,20.15-1.55,26.32-15.12S304.45,75.7,279.63,65.24Zm-81.16-4.5C191,59.4,186.3,48.25,181.74,40.31c-3.54-6.22-2.14-9.43,5.63-9.43a69.86,69.86,0,0,1,12.54,1.55c18.45,3.65,48.36,33.67,48.36,33.67S203.4,61.65,198.47,60.74Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M581.05,210.55q-11.59,16.59-32.33,24.81t-48.29,8.22q-27.87,0-49.47-13.07t-33.42-37.18q-11.82-24.11-12.13-55.89V117.56q0-51.49,24-79.83T497,9.39q35.68,0,57.45,18.24t26.61,51.74H551Q542.55,34,497.14,34q-30.21,0-45.79,21.23t-15.73,61.49v18.65q0,38.39,17.53,61T500.59,219q16.91,0,29.58-3.75a45.68,45.68,0,0,0,21-12.65V151.53H498.4V127h82.65Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M661.2,151.22v89.23H631.14V12.52H715.2q37.42,0,58.63,19.1T795,82.18q0,33.19-20.74,51.11t-59.41,17.93Zm0-24.58h54q24.1,0,36.95-11.37T765,82.42Q765,62,752.15,49.8T716.93,37.1H661.2Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M917,148.24H863.45v92.21H833.24V12.52h75.45q38.5,0,59.25,17.54t20.74,51q0,21.28-11.5,37.1t-32,23.64l53.54,96.74v1.88H966.45Zm-53.54-24.57h46.18q22.38,0,35.61-11.61t13.23-31q0-21.16-12.6-32.46T909.47,37.1h-46Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1142.4,240.45h-30.05V12.52h30.05Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1220.2,71.07l.94,21.29q19.41-24.42,50.72-24.42,53.7,0,54.17,60.58V240.45h-29V128.36q-.16-18.32-8.38-27.08t-25.59-8.76a41.8,41.8,0,0,0-24.74,7.51,51.1,51.1,0,0,0-16.59,19.72v120.7h-29V71.07Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1468.32,195.52q0-11.75-8.84-18.24t-30.84-11.19q-22-4.69-34.91-11.27t-19.1-15.65q-6.18-9.09-6.18-21.61,0-20.82,17.61-35.22t45-14.4q28.8,0,46.72,14.87t17.93,38H1466.6q0-11.89-10.1-20.51t-25.43-8.61q-15.83,0-24.74,6.89a21.67,21.67,0,0,0-8.92,18q0,10.5,8.3,15.81t30,10.18q21.69,4.84,35.15,11.58t20,16.21q6.48,9.47,6.49,23.08,0,22.71-18.16,36.4T1432,243.58q-20.34,0-36-7.2t-24.5-20.12a48.44,48.44,0,0,1-8.84-27.94h29q.78,14.55,11.66,23.09t28.72,8.53q16.44,0,26.38-6.65T1468.32,195.52Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1535.16,26.14a17.27,17.27,0,0,1,4.31-11.89q4.3-4.86,12.76-4.86t12.83,4.86a17.1,17.1,0,0,1,4.39,11.89,16.55,16.55,0,0,1-4.39,11.74q-4.38,4.69-12.83,4.7t-12.76-4.7A16.71,16.71,0,0,1,1535.16,26.14Zm31.31,214.31h-29V71.07h29Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1605.92,154.35q0-39.6,18.32-63t48.52-23.4q31,0,48.38,21.91l1.4-18.78H1749V236.38q0,32.87-19.49,51.81t-52.36,18.94a87.25,87.25,0,0,1-35.85-7.82q-17.54-7.83-26.77-21.45l15-17.38q18.63,23,45.55,23,21.14,0,33-11.9t11.82-33.5V223.54q-17.37,20-47.43,20-29.75,0-48.13-24T1605.92,154.35Zm29.12,3.29q0,28.63,11.74,45T1679.65,219q27.39,0,40.23-24.89V116.78Q1706.57,92.51,1680,92.52q-21.12,0-33,16.43T1635,157.64Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1821.63,91.58q19.26-23.64,50.1-23.64,53.68,0,54.16,60.58V240.45h-29V128.36q-.17-18.32-8.37-27.08T1863,92.52a41.77,41.77,0,0,0-24.73,7.51,51,51,0,0,0-16.6,19.72v120.7h-29V0h29Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2008.54,30.06v41h31.63V93.46h-31.63V198.63q0,10.19,4.23,15.28t14.4,5.09a70.4,70.4,0,0,0,13.78-1.88v23.35a84.65,84.65,0,0,1-22.23,3.11q-19.41,0-29.27-11.74t-9.87-33.35v-105h-30.83V71.07h30.83v-41Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2172.6,195.52q0-11.75-8.85-18.24t-30.83-11.19q-22-4.69-34.91-11.27t-19.1-15.65q-6.18-9.09-6.18-21.61,0-20.82,17.61-35.22t45-14.4q28.8,0,46.73,14.87t17.92,38h-29.11q0-11.89-10.1-20.51t-25.44-8.61q-15.81,0-24.73,6.89a21.67,21.67,0,0,0-8.92,18q0,10.5,8.29,15.81t30,10.18q21.67,4.84,35.14,11.58t20,16.21q6.49,9.47,6.5,23.08,0,22.71-18.16,36.4t-47.12,13.7q-20.36,0-36-7.2t-24.5-20.12a48.45,48.45,0,0,1-8.85-27.94h29q.8,14.55,11.67,23.09t28.72,8.53q16.44,0,26.38-6.65T2172.6,195.52Z"
});

function SvgAppIconGprInsightsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2201.56,
    height: 307.13,
    viewBox: "0 0 2201.56 307.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconGprInsightsWhite);
export default __webpack_public_path__ + "static/media/appIconGPRInsightsWhite.135d2f7d.svg";
export { ForwardRef as ReactComponent };